import moment from "moment";
import React from "react";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBG1 } from "../../../../../redux/app/crb/groups/crb-g";
import { commonUtils } from "../../../../../redux/_common";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBC1PreviewProps = OwnProps;
function CRBC1Preview(props: CRBC1PreviewProps) {
	const crbRecord = props.crbRecord as TCRBG1;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "G", 20, renderItem20()],
					[null, null, 21, renderItem21()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderItem20() {
		if (crbRecord.item20P3.tanks.length > 0) {
			const totalLoadedQuantityOfTanks =
				crbRecord.item20P3.tanks.reduce<number>(
					(result, tank) => commonUtils.addUp(tank.transferQuantity, result),
					0
				);
			return (
				<>
					<table className="min-w-full table-auto border-collapse">
						<thead className="bg-gray-600">
							<tr>
								<th className="px-4 py-2 border text-center">Tank</th>
								<th className="px-4 py-2 border text-center">
									Uptake Quantity
								</th>
							</tr>
						</thead>
						<tbody>
							{crbRecord.item20P3.tanks.map((tank) => {
								return (
									<tr key={tank.selectedTank.id}>
										<td className="px-4 py-2 border text-center">
											{tank.selectedTank.tankCode}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.transferQuantity}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<br />
					<h4 className="font-medium uppercase">
						Total Ballast Uptake: {totalLoadedQuantityOfTanks.toFixed(2)} M³
					</h4>
				</>
			);
		}
		return <>----</>;
	}
	function renderItem21() {
		if (crbRecord.item20P3.tanks.length > 0) {
			const smtStartDate = crbRecord.item20P3.tanks[0].startDate;
			const smtStartTime = crbRecord.item20P3.tanks[0].startTime;
			const smtEndDate =
				crbRecord.item20P3.tanks[crbRecord.item20P3.tanks.length - 1].endDate;
			const smtEndTime =
				crbRecord.item20P3.tanks[crbRecord.item20P3.tanks.length - 1].endTime;

			const dateTimeLocal = `${smtStartDate}T${smtStartTime}:00${crbRecord.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);

			if (crbRecord.item20P1.placeOfBallast.place === "IN_PORT") {
				return (
					<>
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) ({smtStartTime} SMT)
							on {moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at{" "}
							{crbRecord.item20P1.placeOfBallast.portName}
						</>
						<br />
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) ({smtEndTime}{" "}
							SMT) on {moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							at {crbRecord.item20P1.placeOfBallast.portName}
						</>
					</>
				);
			} else if (crbRecord.item20P1.placeOfBallast.place === "AT_SEA") {
				return (
					<>
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) ({smtStartTime} SMT)
							on {moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at
							Lat {crbRecord.item20P1.placeOfBallast.startPosition.latitude} /
							Long {crbRecord.item20P1.placeOfBallast.startPosition.longitude}
						</>
						<br />
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) ({smtEndTime}{" "}
							SMT) on {moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							at Lat {crbRecord.item20P1.placeOfBallast.endPosition.latitude} /
							Long {crbRecord.item20P1.placeOfBallast.endPosition.longitude}
						</>
					</>
				);
			}
		}
	}

	return renderMain();
}

export default CRBC1Preview;
